import React from 'react';
import { Empty, Spin } from 'antd';
import ReactECharts from 'echarts-for-react';

const TrafficDistribution = ({ loading, endpoints }) => {
  const getChartOption = () => {
    return {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'horizontal',
        bottom: 10,
        data: endpoints.map(endpoint => endpoint.name)
      },
      series: [
        {
          name: 'Traffic Distribution',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '20',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: endpoints.map(endpoint => ({
            value: endpoint.trafficWeight,
            name: endpoint.name
          }))
        }
      ],
      color: [
        '#1890ff',
        '#52c41a',
        '#faad14',
        '#ff4d4f',
        '#722ed1',
        '#13c2c2',
        '#eb2f96'
      ]
    };
  };

  const renderContent = () => {
    if (loading) {
      return <Spin size="large" />;
    }

    if (!endpoints || endpoints.length === 0) {
      return <Empty description="No endpoints available" />;
    }

    return (
      <ReactECharts
        option={getChartOption()}
        style={{ height: '100%', width: '100%' }}
        opts={{ renderer: 'canvas' }}
      />
    );
  };

  return (
    <div className="traffic-distribution">
      {renderContent()}
    </div>
  );
};

export default TrafficDistribution;
